import { visibilityPct } from '@/lib/format'
import type { Scores } from '@/lib/types'

export function ScoreHero({ scores }: { scores: Partial<Scores> }) {
  const pct = visibilityPct(scores)
  return (
    <div className="h-full p-6 rounded-xl border border-border bg-card relative overflow-hidden">
      <div className="text-xs uppercase tracking-wider text-muted-foreground">
        Weighted Score
      </div>
      <div className="mt-2 flex items-baseline gap-3">
        <span className="text-5xl font-semibold text-foreground tabular-nums">
          {Math.round(scores.total ?? 0)}
        </span>
        <span className="text-2xl text-muted-foreground">
          / {Math.round(scores.max ?? 0)}
        </span>
      </div>
      <div className="mt-5 h-2 rounded-full bg-secondary overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-primary to-accent transition-all duration-1000"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-3 text-sm text-muted-foreground">
        {pct.toFixed(1)}% of the maximum weighted score
      </div>
    </div>
  )
}
